import React, { useState, useCallback } from "react";
import Footer from "../../Reusable/Footer";
import Header from "../../Reusable/Header";
import {
    Box,
    Typography,
    TextField,
    Grid,
    IconButton,
    InputAdornment,
    CircularProgress,
    Link,
    Card,
    Avatar,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUser,
    faLock,
    faEnvelope,
    faEye,
    faEyeSlash,
    faPhone,
    faMapMarkerAlt,
    faGlobe,
    faBuilding,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDropzone } from 'react-dropzone';
import baseURL from "../user/config";
import COLORS from "../../../constants/colors";
import { PrimaryButton, OutlinedButton } from "../../Reusable/Button";

// 🌍 All Countries (East Africa prioritized, abbr = name)
const countryCodes = [
  // --- East African Countries (prioritized) ---
  { code: '+256', name: 'Uganda', abbr: 'Uganda' },
  { code: '+254', name: 'Kenya', abbr: 'Kenya' },
  { code: '+255', name: 'Tanzania', abbr: 'Tanzania' },
  { code: '+250', name: 'Rwanda', abbr: 'Rwanda' },
  { code: '+257', name: 'Burundi', abbr: 'Burundi' },
  { code: '+211', name: 'South Sudan', abbr: 'South Sudan' },
  { code: '+251', name: 'Ethiopia', abbr: 'Ethiopia' },
  { code: '+252', name: 'Somalia', abbr: 'Somalia' },
  { code: '+260', name: 'Zambia', abbr: 'Zambia' },
  { code: '+263', name: 'Zimbabwe', abbr: 'Zimbabwe' },

  // --- Rest of the World (alphabetically) ---
  { code: '+93', name: 'Afghanistan', abbr: 'Afghanistan' },
  { code: '+355', name: 'Albania', abbr: 'Albania' },
  { code: '+213', name: 'Algeria', abbr: 'Algeria' },
  { code: '+1-684', name: 'American Samoa', abbr: 'American Samoa' },
  { code: '+376', name: 'Andorra', abbr: 'Andorra' },
  { code: '+244', name: 'Angola', abbr: 'Angola' },
  { code: '+1-264', name: 'Anguilla', abbr: 'Anguilla' },
  { code: '+1-268', name: 'Antigua and Barbuda', abbr: 'Antigua and Barbuda' },
  { code: '+54', name: 'Argentina', abbr: 'Argentina' },
  { code: '+374', name: 'Armenia', abbr: 'Armenia' },
  { code: '+297', name: 'Aruba', abbr: 'Aruba' },
  { code: '+61', name: 'Australia', abbr: 'Australia' },
  { code: '+43', name: 'Austria', abbr: 'Austria' },
  { code: '+994', name: 'Azerbaijan', abbr: 'Azerbaijan' },
  { code: '+1-242', name: 'Bahamas', abbr: 'Bahamas' },
  { code: '+973', name: 'Bahrain', abbr: 'Bahrain' },
  { code: '+880', name: 'Bangladesh', abbr: 'Bangladesh' },
  { code: '+1-246', name: 'Barbados', abbr: 'Barbados' },
  { code: '+375', name: 'Belarus', abbr: 'Belarus' },
  { code: '+32', name: 'Belgium', abbr: 'Belgium' },
  { code: '+501', name: 'Belize', abbr: 'Belize' },
  { code: '+229', name: 'Benin', abbr: 'Benin' },
  { code: '+975', name: 'Bhutan', abbr: 'Bhutan' },
  { code: '+591', name: 'Bolivia', abbr: 'Bolivia' },
  { code: '+387', name: 'Bosnia and Herzegovina', abbr: 'Bosnia and Herzegovina' },
  { code: '+267', name: 'Botswana', abbr: 'Botswana' },
  { code: '+55', name: 'Brazil', abbr: 'Brazil' },
  { code: '+673', name: 'Brunei Darussalam', abbr: 'Brunei Darussalam' },
  { code: '+359', name: 'Bulgaria', abbr: 'Bulgaria' },
  { code: '+226', name: 'Burkina Faso', abbr: 'Burkina Faso' },
  { code: '+855', name: 'Cambodia', abbr: 'Cambodia' },
  { code: '+237', name: 'Cameroon', abbr: 'Cameroon' },
  { code: '+1', name: 'Canada', abbr: 'Canada' },
  { code: '+238', name: 'Cape Verde', abbr: 'Cape Verde' },
  { code: '+56', name: 'Chile', abbr: 'Chile' },
  { code: '+86', name: 'China', abbr: 'China' },
  { code: '+57', name: 'Colombia', abbr: 'Colombia' },
  { code: '+269', name: 'Comoros', abbr: 'Comoros' },
  { code: '+243', name: 'Congo (Democratic Republic)', abbr: 'Congo (Democratic Republic)' },
  { code: '+242', name: 'Congo (Republic)', abbr: 'Congo (Republic)' },
  { code: '+506', name: 'Costa Rica', abbr: 'Costa Rica' },
  { code: '+385', name: 'Croatia', abbr: 'Croatia' },
  { code: '+53', name: 'Cuba', abbr: 'Cuba' },
  { code: '+357', name: 'Cyprus', abbr: 'Cyprus' },
  { code: '+420', name: 'Czech Republic', abbr: 'Czech Republic' },
  { code: '+45', name: 'Denmark', abbr: 'Denmark' },
  { code: '+20', name: 'Egypt', abbr: 'Egypt' },
  { code: '+503', name: 'El Salvador', abbr: 'El Salvador' },
  { code: '+372', name: 'Estonia', abbr: 'Estonia' },
  { code: '+251', name: 'Ethiopia', abbr: 'Ethiopia' },
  { code: '+358', name: 'Finland', abbr: 'Finland' },
  { code: '+33', name: 'France', abbr: 'France' },
  { code: '+49', name: 'Germany', abbr: 'Germany' },
  { code: '+233', name: 'Ghana', abbr: 'Ghana' },
  { code: '+30', name: 'Greece', abbr: 'Greece' },
  { code: '+852', name: 'Hong Kong', abbr: 'Hong Kong' },
  { code: '+36', name: 'Hungary', abbr: 'Hungary' },
  { code: '+354', name: 'Iceland', abbr: 'Iceland' },
  { code: '+91', name: 'India', abbr: 'India' },
  { code: '+62', name: 'Indonesia', abbr: 'Indonesia' },
  { code: '+98', name: 'Iran', abbr: 'Iran' },
  { code: '+964', name: 'Iraq', abbr: 'Iraq' },
  { code: '+353', name: 'Ireland', abbr: 'Ireland' },
  { code: '+972', name: 'Israel', abbr: 'Israel' },
  { code: '+39', name: 'Italy', abbr: 'Italy' },
  { code: '+81', name: 'Japan', abbr: 'Japan' },
  { code: '+962', name: 'Jordan', abbr: 'Jordan' },
  { code: '+7', name: 'Kazakhstan', abbr: 'Kazakhstan' },
  { code: '+850', name: 'North Korea', abbr: 'North Korea' },
  { code: '+82', name: 'South Korea', abbr: 'South Korea' },
  { code: '+965', name: 'Kuwait', abbr: 'Kuwait' },
  { code: '+856', name: 'Laos', abbr: 'Laos' },
  { code: '+371', name: 'Latvia', abbr: 'Latvia' },
  { code: '+961', name: 'Lebanon', abbr: 'Lebanon' },
  { code: '+231', name: 'Liberia', abbr: 'Liberia' },
  { code: '+218', name: 'Libya', abbr: 'Libya' },
  { code: '+423', name: 'Liechtenstein', abbr: 'Liechtenstein' },
  { code: '+370', name: 'Lithuania', abbr: 'Lithuania' },
  { code: '+352', name: 'Luxembourg', abbr: 'Luxembourg' },
  { code: '+853', name: 'Macau', abbr: 'Macau' },
  { code: '+389', name: 'North Macedonia', abbr: 'North Macedonia' },
  { code: '+261', name: 'Madagascar', abbr: 'Madagascar' },
  { code: '+265', name: 'Malawi', abbr: 'Malawi' },
  { code: '+60', name: 'Malaysia', abbr: 'Malaysia' },
  { code: '+960', name: 'Maldives', abbr: 'Maldives' },
  { code: '+223', name: 'Mali', abbr: 'Mali' },
  { code: '+356', name: 'Malta', abbr: 'Malta' },
  { code: '+52', name: 'Mexico', abbr: 'Mexico' },
  { code: '+377', name: 'Monaco', abbr: 'Monaco' },
  { code: '+212', name: 'Morocco', abbr: 'Morocco' },
  { code: '+264', name: 'Namibia', abbr: 'Namibia' },
  { code: '+977', name: 'Nepal', abbr: 'Nepal' },
  { code: '+31', name: 'Netherlands', abbr: 'Netherlands' },
  { code: '+64', name: 'New Zealand', abbr: 'New Zealand' },
  { code: '+234', name: 'Nigeria', abbr: 'Nigeria' },
  { code: '+47', name: 'Norway', abbr: 'Norway' },
  { code: '+968', name: 'Oman', abbr: 'Oman' },
  { code: '+92', name: 'Pakistan', abbr: 'Pakistan' },
  { code: '+970', name: 'Palestine', abbr: 'Palestine' },
  { code: '+507', name: 'Panama', abbr: 'Panama' },
  { code: '+595', name: 'Paraguay', abbr: 'Paraguay' },
  { code: '+51', name: 'Peru', abbr: 'Peru' },
  { code: '+63', name: 'Philippines', abbr: 'Philippines' },
  { code: '+48', name: 'Poland', abbr: 'Poland' },
  { code: '+351', name: 'Portugal', abbr: 'Portugal' },
  { code: '+974', name: 'Qatar', abbr: 'Qatar' },
  { code: '+40', name: 'Romania', abbr: 'Romania' },
  { code: '+7', name: 'Russia', abbr: 'Russia' },
  { code: '+966', name: 'Saudi Arabia', abbr: 'Saudi Arabia' },
  { code: '+65', name: 'Singapore', abbr: 'Singapore' },
  { code: '+27', name: 'South Africa', abbr: 'South Africa' },
  { code: '+34', name: 'Spain', abbr: 'Spain' },
  { code: '+94', name: 'Sri Lanka', abbr: 'Sri Lanka' },
  { code: '+46', name: 'Sweden', abbr: 'Sweden' },
  { code: '+41', name: 'Switzerland', abbr: 'Switzerland' },
  { code: '+963', name: 'Syria', abbr: 'Syria' },
  { code: '+886', name: 'Taiwan', abbr: 'Taiwan' },
  { code: '+66', name: 'Thailand', abbr: 'Thailand' },
  { code: '+90', name: 'Turkey', abbr: 'Turkey' },
  { code: '+256', name: 'Uganda', abbr: 'Uganda' },
  { code: '+380', name: 'Ukraine', abbr: 'Ukraine' },
  { code: '+971', name: 'United Arab Emirates', abbr: 'United Arab Emirates' },
  { code: '+44', name: 'United Kingdom', abbr: 'United Kingdom' },
  { code: '+1', name: 'United States', abbr: 'United States' },
  { code: '+598', name: 'Uruguay', abbr: 'Uruguay' },
  { code: '+998', name: 'Uzbekistan', abbr: 'Uzbekistan' },
  { code: '+58', name: 'Venezuela', abbr: 'Venezuela' },
  { code: '+84', name: 'Vietnam', abbr: 'Vietnam' },
  { code: '+260', name: 'Zambia', abbr: 'Zambia' },
  { code: '+263', name: 'Zimbabwe', abbr: 'Zimbabwe' },
];


const OrganizationOnboarding = () => {
    const navigate = useNavigate();

    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    // New State for Country Code, defaulted to Uganda
    const [selectedOrgCode, setSelectedOrgCode] = useState(countryCodes[0].code);

    // Use a single state object for all form data
    const [formData, setFormData] = useState({
        orgName: "",
        orgType: "",
        orgEmail: "",
        orgPhone: "", // This now holds the national number part only
        orgPhysicalAddress: "",
        orgWebsite: "",
        logoFile: null,
        logoPreview: null,
        adminFullName: "",
        adminEmail: "",
        adminPassword: "",
        adminConfirmPassword: "",
    });

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === 'orgPhone') {
            // Remove leading '0' if it exists for the national number part
            if (value.startsWith('0')) {
                value = value.substring(1);
            }
            // Ensure only digits are entered
            value = value.replace(/\D/g, '');
        }
        
        setFormData({ ...formData, [name]: value });
    };

    const handleOrgCodeChange = (e) => {
        setSelectedOrgCode(e.target.value);
    };

    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles.length === 0) return;
        const file = acceptedFiles[0];
        const previewUrl = URL.createObjectURL(file);

        setFormData((prev) => ({
            ...prev,
            logoFile: file,
            logoPreview: previewUrl,
        }));
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { 'image/*': [] },
        multiple: false,
        maxFiles: 1,
    });

    const validateStep1 = () => {
        if (
            !formData.orgName.trim() ||
            !formData.orgType.trim() || // Validate orgType
            !formData.orgEmail.trim() ||
            !formData.orgPhone.trim() ||
            !formData.orgPhysicalAddress.trim()
        ) {
            toast.error("Please fill in all required organization fields.");
            return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.orgEmail)) {
            toast.error("Please enter a valid organization email address.");
            return false;
        }
        
        // **Updated Phone Validation for International Format**
        const fullPhoneNumber = `${selectedOrgCode}${formData.orgPhone}`;
        const internationalPhoneRegex = /^\+\d{8,15}$/; 
        
        if (!internationalPhoneRegex.test(fullPhoneNumber)) {
            toast.error('Please enter a valid international phone number (8 to 15 digits).');
            return false;
        }
        // End of updated validation
        
        return true;
    };

    const validateStep2 = () => {
        if (
            !formData.adminFullName.trim() ||
            !formData.adminEmail.trim() ||
            !formData.adminPassword ||
            !formData.adminConfirmPassword
        ) {
            toast.error("Please fill in all required admin user fields.");
            return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.adminEmail)) {
            toast.error("Please enter a valid admin email address.");
            return false;
        }
    
        const passwordRegex =
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(formData.adminPassword)) {
            toast.error(
                "Password must be at least 8 characters, include one letter, one number, and one special character."
            );
            return false;
        }
        if (formData.adminPassword !== formData.adminConfirmPassword) {
            toast.error("Passwords do not match!");
            return false;
        }
        return true;
    };

    const handleNext = () => {
        if (step === 1 && validateStep1()) {
            setStep(2);
        } else if (step === 2 && validateStep2()) {
            setStep(3);
        }
    };

    const handleBack = () => {
        if (step > 1) setStep(step - 1);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!agreedToTerms) {
            toast.error("You must agree to the terms to proceed.");
            return;
        }

        setLoading(true);
        
        // Construct the full phone number for submission
        const fullOrgPhoneNumber = `${selectedOrgCode}${formData.orgPhone}`;


        try {
            const payload = new FormData();
            // Append all fields to the payload
            payload.append('orgName', formData.orgName);
            payload.append('orgType', formData.orgType);
            payload.append('orgEmail', formData.orgEmail);
            // **Send the full international phone number**
            payload.append('orgPhone', fullOrgPhoneNumber); 
            payload.append('orgPhysicalAddress', formData.orgPhysicalAddress);
            payload.append('orgWebsite', formData.orgWebsite);
            payload.append('adminFullName', formData.adminFullName);
            payload.append('adminEmail', formData.adminEmail);
            payload.append('adminPassword', formData.adminPassword);
            payload.append('adminConfirmPassword', formData.adminConfirmPassword);
            
            // Append the logo file
            if (formData.logoFile) {
                payload.append('logoFile', formData.logoFile);
            }

            const response = await fetch(`${baseURL}/org/onboard`, {
                method: "POST",
                body: payload,
            });

            const data = await response.json();

            if (response.ok) {
                // Handle success response from the backend
                toast.success(data.message);
                
                // Reset form and redirect
                setStep(1);
                setFormData({
                    orgName: "",
                    orgType: "",
                    orgEmail: "",
                    orgPhone: "",
                    orgPhysicalAddress: "",
                    orgWebsite: "",
                    logoFile: null,
                    logoPreview: null,
                    adminFullName: "",
                    adminEmail: "",
                    adminPhone: "",
                    adminPassword: "",
                    adminConfirmPassword: "",
                });
                setSelectedOrgCode(countryCodes[0].code); // Reset code as well
                setAgreedToTerms(false);
                setTimeout(() => navigate("/user/login"), 2000);
            } else {
                // Handle all backend-returned errors
                toast.error(data.error || "Failed to create organization");
            }

        } catch (error) {
            // Handle network errors
            toast.error("An unexpected error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <Header />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                    backgroundColor: "#fff",
                    p: 3,
                }}
            >
                <Card sx={{ maxWidth: 600, width: "100%", p: { xs: 2, sm: 4 }, borderRadius: 2, boxShadow: 0 }}>
                    <Typography
                        variant="h4"
                        fontWeight="bold"
                        color={COLORS.primary}
                        mb={4}
                        textAlign="left"
                        sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}
                    >
                        Organization Onboarding
                    </Typography>

                    <form onSubmit={handleSubmit} noValidate>
                        {step === 1 && (
                            <>
                                <Typography variant="h6" mb={3} color={COLORS.primary}>
                                    Organization Details
                                </Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Box {...getRootProps()} sx={{ border: '2px dashed', borderColor: isDragActive ? COLORS.primary : COLORS.primary + '88', borderRadius: 3, p: 3, textAlign: 'center', cursor: 'pointer', display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 2, justifyContent: 'center', minHeight: 96, mb: 3 }}>
                                            <input {...getInputProps()} />
                                            <Avatar
                                                src={formData.logoPreview}
                                                sx={{ width: 64, height: 64, mx: 'auto', bgcolor: COLORS.primary, transition: 'transform 0.3s' }}
                                            >
                                                {!formData.logoPreview && <FontAwesomeIcon icon={faBuilding} style={{ fontSize: '24px' }} />}
                                            </Avatar>
                                            <Typography sx={{ fontSize: '0.85rem', color: isDragActive ? COLORS.primary : COLORS.primary + 'aa', userSelect: 'none' }}>
                                                {isDragActive ? 'Drop the logo here ...' : 'Drag & drop your logo, or click to select'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Organization Name"
                                            name="orgName"
                                            value={formData.orgName}
                                            onChange={handleChange}
                                            fullWidth
                                            required
                                            variant="outlined"
                                            InputLabelProps={{ style: { color: COLORS.primary } }}
                                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FontAwesomeIcon icon={faBuilding} style={{ color: COLORS.primary }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <FormControl fullWidth variant="outlined" sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}>
                                            <InputLabel id="org-type-label" style={{ color: COLORS.primary }}>
                                                Organization Type
                                            </InputLabel>
                                            <Select
                                                labelId="org-type-label"
                                                id="org-type-select"
                                                name="orgType"
                                                value={formData.orgType}
                                                onChange={handleChange}
                                                label="Organization Type"
                                                required
                                            >
                                                <MenuItem value="CSO">CSO - Community-Based Organization</MenuItem>
                                                <MenuItem value="NGO">NGO - Non-Governmental Organization</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            label="Organization Email"
                                            name="orgEmail"
                                            value={formData.orgEmail}
                                            onChange={handleChange}
                                            fullWidth
                                            required
                                            variant="outlined"
                                            InputLabelProps={{ style: { color: COLORS.primary } }}
                                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FontAwesomeIcon icon={faEnvelope} style={{ color: COLORS.primary }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    {/* --- START Phone Number with Country Code Select --- */}
                                    <Grid item xs={12} sm={12}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={4}>
                                                {/* Country Code Select Dropdown */}
                                                <FormControl fullWidth variant="outlined" sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}>
                                                    <Select
                                                        value={selectedOrgCode}
                                                        onChange={handleOrgCodeChange}
                                                        sx={{ color: COLORS.primary, fontWeight: 'bold' }}
                                                        inputProps={{ 'aria-label': 'Country Code' }}
                                                    >
                                                        {countryCodes.map((country) => (
                                                            <MenuItem key={country.code} value={country.code}>
                                                                {country.abbr} {country.code}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={8}>
                                                {/* Phone Number Input */}
                                                <TextField
                                                    name="orgPhone"
                                                    label="Phone Number"
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    value={formData.orgPhone}
                                                    onChange={handleChange}
                                                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
                                                    InputLabelProps={{ style: { color: COLORS.primary } }}
                                                    InputProps={{
                                                        style: { color: COLORS.text },
                                                        startAdornment: (<InputAdornment position="start"><FontAwesomeIcon icon={faPhone} style={{ color: COLORS.primary }} /></InputAdornment>),
                                                        inputProps: { inputMode: "numeric" }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>


                                    <Grid item xs={12}>
                                        <TextField
                                            label="Physical Address"
                                            name="orgPhysicalAddress"
                                            value={formData.orgPhysicalAddress}
                                            onChange={handleChange}
                                            fullWidth
                                            required
                                            variant="outlined"
                                            InputLabelProps={{ style: { color: COLORS.primary } }}
                                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: COLORS.primary }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            label="Website (Optional)"
                                            name="orgWebsite"
                                            value={formData.orgWebsite}
                                            onChange={handleChange}
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{ style: { color: COLORS.primary } }}
                                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FontAwesomeIcon icon={faGlobe} style={{ color: COLORS.primary }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        )}

                        {step === 2 && (
                            <>
                                <Typography variant="h6" mb={3} color={COLORS.primary}>
                                    Admin User Details
                                </Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Full Name"
                                            name="adminFullName"
                                            value={formData.adminFullName}
                                            onChange={handleChange}
                                            fullWidth
                                            required
                                            variant="outlined"
                                            InputLabelProps={{ style: { color: COLORS.primary } }}
                                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FontAwesomeIcon icon={faUser} style={{ color: COLORS.primary }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            label="Email"
                                            name="adminEmail"
                                            value={formData.adminEmail}
                                            onChange={handleChange}
                                            fullWidth
                                            required
                                            variant="outlined"
                                            InputLabelProps={{ style: { color: COLORS.primary } }}
                                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FontAwesomeIcon icon={faEnvelope} style={{ color: COLORS.primary }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    

                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            label="Password"
                                            name="adminPassword"
                                            type={showPassword ? "text" : "password"}
                                            value={formData.adminPassword}
                                            onChange={handleChange}
                                            fullWidth
                                            required
                                            variant="outlined"
                                            InputLabelProps={{ style: { color: COLORS.primary } }}
                                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FontAwesomeIcon icon={faLock} style={{ color: COLORS.primary }} />
                                                    </InputAdornment>
                                                ),
                                                endAdornment: (
                                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                                        <FontAwesomeIcon
                                                            icon={showPassword ? faEyeSlash : faEye}
                                                            style={{ fontSize: "16px", color: COLORS.primary }}
                                                        />
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            label="Confirm Password"
                                            name="adminConfirmPassword"
                                            type={showConfirmPassword ? "text" : "password"}
                                            value={formData.adminConfirmPassword}
                                            onChange={handleChange}
                                            fullWidth
                                            required
                                            variant="outlined"
                                            InputLabelProps={{ style: { color: COLORS.primary } }}
                                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FontAwesomeIcon icon={faLock} style={{ color: COLORS.primary }} />
                                                    </InputAdornment>
                                                ),
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                            edge="end"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={showConfirmPassword ? faEyeSlash : faEye}
                                                                style={{ fontSize: "16px", color: COLORS.primary }}
                                                            />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        )}

                        {step === 3 && (
                            <Box mb={3}>
                                <Typography variant="h6" mb={2} color={COLORS.primary}>
                                    Review and Agree
                                </Typography>
                                <Typography variant="body1" color={COLORS.text} mb={2}>
                                    Please review your details and agree to our terms to complete
                                    onboarding.
                                </Typography>

                                <Box display="flex" alignItems="center" mb={2}>
                                    <input
                                        type="checkbox"
                                        id="terms"
                                        checked={agreedToTerms}
                                        onChange={(e) => setAgreedToTerms(e.target.checked)}
                                        style={{ marginRight: 8, transform: 'scale(1.2)' }}
                                    />
                                    <label htmlFor="terms" style={{ color: COLORS.text, fontSize: "0.875rem" }}>
                                        I agree to the&nbsp;
                                        <Link
                                            href="/terms-of-use"
                                            target="_blank"
                                            rel="noopener"
                                            underline="hover"
                                            style={{
                                                color: COLORS.primary,
                                                textDecoration: "underline",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Terms of Use
                                        </Link>{" "}
                                        and&nbsp;
                                        <Link
                                            href="/privacy-policy"
                                            target="_blank"
                                            rel="noopener"
                                            underline="hover"
                                            style={{
                                                color: COLORS.primary,
                                                textDecoration: "underline",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Privacy Policy
                                        </Link>
                                    </label>
                                </Box>
                            </Box>
                        )}

                        <Box display="flex" justifyContent="space-between" mt={4}>
                            {step > 1 && (
                                <OutlinedButton onClick={handleBack}>
                                    Back
                                </OutlinedButton>
                            )}

                            {step < 3 && (
                                <PrimaryButton onClick={handleNext}>
                                    Next
                                </PrimaryButton>
                            )}

                            {step === 3 && (
                                <PrimaryButton
                                    type="submit"
                                    disabled={!agreedToTerms || loading}
                                >
                                    {loading ? (
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <CircularProgress size={16} color="inherit" />
                                            Completing...
                                        </Box>
                                    ) : (
                                        "Complete Onboarding"
                                    )}
                                </PrimaryButton>
                            )}
                        </Box>
                    </form>
                </Card>
            </Box>
            <Footer />
        </>
    );
};

export default OrganizationOnboarding;